import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { Reference } from "../reference";
import { ReferenceService } from "../reference.service";
import { SearchReferenceRequest } from "../search-reference-request";
import { AbstractReferenceSearchComponent } from "./abstract-reference-search.component";
import { AuthorSearchCriteriaComponent } from "./criteria/author-search-criteria.component";
import { GenreSearchCriteriaComponent } from "./criteria/genre-search-criteria.component";
import { PublisherSearchCriteriaComponent } from "./criteria/publisher-search-criteria.component";
import { SelectableReferenceResultComponent } from "./selectable-reference-result.component";

@Component({
  styleUrls: ['./reference-search-dialog.component.css'],
  templateUrl: './reference-search-dialog.component.html'
})
export class ReferenceSearchDialogComponent extends AbstractReferenceSearchComponent {
  @ViewChild(AuthorSearchCriteriaComponent)
  authorCriteria!: AuthorSearchCriteriaComponent;

  @ViewChild(GenreSearchCriteriaComponent)
  genreCriteria!: GenreSearchCriteriaComponent;

  @ViewChild(PublisherSearchCriteriaComponent)
  publisherCriteria!: PublisherSearchCriteriaComponent;

  public onAddReferences!: (references: Reference[]) => Observable<void>;

  constructor(
    referenceService: ReferenceService,
    public activeModal: NgbActiveModal,
  ) {
    super(referenceService);
  }

  public addReferences(): void {
    this.onAddReferences(Array.from(this.selectedResults.values()))

      .subscribe(()=>this.activeModal.close());
  }

  protected customizeSearchRequest(_: SearchReferenceRequest): void {
    
  }

  ngOnInit(): void {
    this.referenceService.onReferencesRefresh().subscribe(initSearch => this.onSearchInit(initSearch));
  }

  ngAfterViewInit(): void {
    this.refreshChildComponent(this.authorCriteria, this.genreCriteria, this.publisherCriteria);
  }

  public refresh() {
    this.search();
  }
}